module.exports = __webpack_public_path__ + "static/octobercms_logo-11e6feaa42ffe9ae80f3d895e26fd33e.svg";